/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { InputTitle, InputWrapper, FieldLabelWrapper } from './css';
import Note from '../../note';
import { fieldEeEnterEmailSigningAuthority } from '../../utils/constant';
import FieldGuide from './common/fieldGuide';
import FieldTitle from './common/FieldTitle';
import formFieldOperationOptions from '../../utils/formFieldOperationOptions';
import FieldLocationInput from './fieldLocationInput';

const FieldInput = ({ data }) => {
  const {
    ref,
    name,
    type,
    label,
    value,
    title,
    required,
    placeholder,
    maxLength,
    minLength,
    onChange,
    readonly,
    tooltip,
    note,
    disabled,
    tooltipLong,
    toolTipRichText,
    noteType,
    noteAppearsBelowField = false,
    isShowNoteBackground,
    isLabelBold
  } = data;

  const renderNotes = () => {
    return (
      note &&
      note.content && (
        <Note
          type="richText"
          variant={noteType}
          options={formFieldOperationOptions(value)}
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )
    );
  };

  const onInputChange = e => {
    if (type === 'Number') {
      const {
        target: { value: currentValue }
      } = e;
      if (parseInt(currentValue, 10) < 0) {
        e.target.value = 0;
      }
    }
    onChange(e);
  };

  const tooltipMessage = tooltip || tooltipLong || toolTipRichText;
  return (
    <>
      {title && <InputTitle>{title}</InputTitle>}
      <InputWrapper>
        {!noteAppearsBelowField && renderNotes()}
        <FieldLabelWrapper>
          <FieldTitle required={required} label={label} isLabelBold={data.isLabelBold} />
          {tooltipMessage && (
            <FieldGuide tooltip={tooltipMessage} isRichText={toolTipRichText} />
          )}
        </FieldLabelWrapper>
        {type === 'Address' || type === 'AddressDetails' ? (
          <FieldLocationInput data={data} />
        ) : (
          <input
            ref={ref}
            id={name}
            name={name}
            type={type}
            value={value}
            maxLength={maxLength}
            minLength={minLength}
            readOnly={readonly}
            placeholder={placeholder}
            disabled={disabled}
            onPaste={e =>
              name === fieldEeEnterEmailSigningAuthority && e.preventDefault()
            }
            className="frg-input-field color-light"
            style={{ width: '100%', backgroundColor: '#fff' }}
            onChange={onInputChange}
            onWheel={type === 'Number' ? (e) => e.currentTarget.blur() : undefined}
          />
        )}
        {noteAppearsBelowField && renderNotes()}
      </InputWrapper>
    </>
  );
};

FieldInput.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    title: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipLong: PropTypes.string,
    toolTipRichText: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    noteType: PropTypes.string.isRequired,
    noteAppearsBelowField: PropTypes.bool.isRequired,
    isShowNoteBackground: PropTypes.bool,
    isLabelBold: PropTypes.bool
  }).isRequired
};

export default FieldInput;
